"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";
import CuoButton from "@/app/admin/_common/CuoButton";
import { useFestivalsModel } from "./festivalsPageModel";
import FestivalsToolbar from "./_cmp/FestivalsToolbar";
import FestivalList from "./_cmp/FestivalList";
import FestivalListSkeleton from "./_cmp/FestivalListSkeleton";
import { FestivalDialog } from "./_cmp/festivalForm/FestivalDialog";
import { PlusCircle, PartyPopper } from "lucide-react";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function FestivalsPage() {
  const {
    filteredFestivals,
    isLoading,
    search,
    setSearch,
    selectedFestival,
    openForm,
    openCreateForm,
    openEditForm,
    closeForm,
    handleDelete,
    handleTogglePublish,
    refetch,
  } = useFestivalsModel();
  const isMobile = useIsMobile();

  const newFestivalButton = (
    <CuoButton
      variant={isMobile ? "outline" : "default"}
      label={<span className="hidden sm:inline">New festival</span>}
      icon={<PlusCircle className="size-3.5 shrink-0" size={14} />}
      onClick={openCreateForm}
      className="px-2 sm:px-3"
      aria-label="New festival"
    />
  );

  const list = isLoading ? (
    <FestivalListSkeleton />
  ) : (
    <FestivalList
      festivals={filteredFestivals}
      onEdit={openEditForm}
      onDelete={handleDelete}
      onTogglePublish={handleTogglePublish}
    />
  );

  if (isMobile) {
    return (
      <PageContainer flush>
        <div className="flex h-full w-full flex-col overflow-y-auto">
          <div className="sticky top-0 z-10 flex flex-col gap-2 border-b border-border bg-card/80 px-3 py-2 backdrop-blur-sm">
            <PageHeader
              title="Festivals"
              icon={PartyPopper}
              subtitle={`${filteredFestivals.length} festivals`}
              actions={newFestivalButton}
              className="static bg-transparent p-0 backdrop-blur-none"
            />
            <FestivalsToolbar search={search} onSearchChange={setSearch} />
          </div>

          <div className="flex flex-1 flex-col pb-3">{list}</div>
        </div>

        <FestivalDialog
          open={openForm}
          defaultFestival={selectedFestival}
          onClose={closeForm}
          onSaved={refetch}
        />
      </PageContainer>
    );
  }

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader
          title="Festivals"
          icon={PartyPopper}
          subtitle={`${filteredFestivals.length} festivals`}
          actions={newFestivalButton}
        />

        <div className="flex min-h-0 flex-1 flex-col gap-3 px-5 py-5">
          <FestivalsToolbar search={search} onSearchChange={setSearch} />

          <div className="flex min-h-0 flex-1 flex-col">{list}</div>
        </div>
      </div>

      <FestivalDialog
        open={openForm}
        defaultFestival={selectedFestival}
        onClose={closeForm}
        onSaved={refetch}
      />
    </PageContainer>
  );
}
